import four from '../assets/svg/projects/memusic.svg';

export const projectsData = [
  {
    id: 1,
    projectName: 'Campus Connect',
    projectDesc: 'Maximise conversion by generating stronger applicant communities',
    tags: ['React Native', 'Meteor', 'Blaze'],
    demo: 'https://www.campusconnect.ie/',
    code: '',
    image:
      'https://images.squarespace-cdn.com/content/v1/5d892f94afd4fc4e074a830f/cda5eb15-9eaa-46fc-85dd-fb50272c9976/CampusConnect+logo+squarespace.png?format=1500w',
  },
  {
    id: 2,
    projectName: 'Feeling Better Now',
    projectDesc:
      'FeelingBetterNow® helps employees, families and health providers confidentially identify and manage mental health problems early in line with best practices.',
    tags: ['React Js', 'Bootstrap'],
    demo: 'https://feelingbetternow.com/',
    code: '',
    image:
      'https://feelingbetternow.com/static/media/FeelingBetterNowLogo.06eefb0dfb8031f27df7843dd37e1e1b.svg',
  },
  {
    id: 3,
    projectName: 'Tropical Sky, Booking Module',
    projectDesc:
      'Tropical Sky is a travel company with a difference. We are here to genuinely offer you the best service and advice possible to ensure we create a tailor-made luxury holiday to satisfy your travel requirements.',
    tags: ['React Js', 'Redux-toolkit', 'Material Ui'],
    demo: 'https://www.tropicalsky.co.uk/',
    code: '',
    image: 'https://www.tropicalsky.co.uk/FrontEndGlobalAssets/dist/img/brands/tropicalsky.svg',
  },
  {
    id: 4,
    projectName: 'MeMusic',
    projectDesc: 'MeMusic is a blockchain end-to-end platform designed to create, listen, and share music.',
    tags: ['Next Js', 'Material Ui', 'GraphQL'],
    demo: 'https://www.memusic.io/',
    code: '',
    image: four,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
